import { render, staticRenderFns } from "./doctor-details.vue?vue&type=template&id=7a6cc258&"
import script from "./doctor-details.vue?vue&type=script&lang=js&"
export * from "./doctor-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports